module.exports = __webpack_public_path__ + "img/Group 8 Copy@412x.a4c54646.png";